import React, { useState } from "react";
import DraggableBooleanCreationElement from "./DraggableBooleanCreationElement";
import DraggableCommentCreationElement from "./DraggableCommentCreationElement";
import DraggableRatingCreationElement from "./DraggableRatingCreationElement";
import DraggableTextCreationElement from "./DraggableTextCreationElement";
import { v4 as uuidv4 } from "uuid";
import DraggableRankingDropdownRadiogroupCheckboxCreationElement from "./DraggableDropdownRadiogroupCheckboxCreationelement";
import {
    Box,
    HStack,
    IconButton,
    Tooltip,
    FormControl,
    FormLabel,
    Switch,
    Input,
    VStack,
    Text,
    Select,
   Button, 
   List, 
   ListItem
} from "@chakra-ui/react";
import {
    DeleteIcon,
    EditIcon,
    CopyIcon,
    ArrowUpIcon,
    ArrowDownIcon,
    CloseIcon,
} from "@chakra-ui/icons";
import { useEffect } from "react";
function DraggableMatrixDropdownCreationElement({
  
    element,
    onDelete,
    onEdit,
    onCopy,
    onMoveUp,
    onMoveDown,
    onChangeData,
    isMatrixDropdownElement,
    onDeleteMatrixDropdown,
    onCopyMatrixDropdown,
    onMoveUpMatrixDropdown,
    onMoveDownMatrixDropdown 

}) {
    const [selectedType, setSelectedType] = useState("");
    const [columns, setColumns] = useState(element.columns || []); // Inizializza lo stato locale

    const handleTypeChange = (event) => {
        console.log("Selected value:", event.target.value);
        setSelectedType(event.target.value); // Impost
    };

  // Sincronizza lo stato locale con il genitore
  useEffect(() => {
    if (JSON.stringify(columns) !== JSON.stringify(element.columns)) {
      onChangeData(element.id, "columns", columns); // Aggiorna il genitore solo se necessario
    }
  }, [columns, element.id, element.columns, onChangeData]);



    useEffect(() => {
    
        if (element.isRequired == null) {
          onChangeData(element.id, "isRequired", false);
        }

        if (!element.columns) {
          onChangeData(element.id, "columns", []);
        }

        if (!element.rows) {
          onChangeData(element.id, "rows", []);
        }
        
      }, [ element, onChangeData]);
    

    
    
    const [newRow, setNewRow] = useState({ value: "", text: "" });
  
  
    
    const [rows, setRows] = useState(element.rows ||[]);
  

    const handleAddColumn = (newColumn) => {
      setColumns((prevColumns) => [...prevColumns, newColumn]); // Aggiorna solo lo stato locale
    };
      
      const handleAddRow = () => {
        if (newRow.value && newRow.text) {
          const isDuplicate = rows.some(
            (row) => row.value === newRow.value && row.text === newRow.text
          );
      
          if (!isDuplicate) {
            const updatedRows = [...rows, newRow]; // Aggiorna localmente l'array delle righe
            setRows(updatedRows); // Aggiorna lo stato locale delle righe
            onChangeData(element.id, "rows", updatedRows); // Notifica l'aggiornamento tramite onChangeData
           
            setNewRow({ value: "", text: "" }); // Resetta l'oggetto riga
          } 
        }
      };
      
      const handleRemoveColumn = (columnIdToRemove) => {
        const updatedColumns = columns.filter((column) => column.id !== columnIdToRemove); // Rimuove la colonna con l'id specificato
        setColumns(updatedColumns); // Aggiorna lo stato locale delle colonne
        onChangeData(element.id, "columns", updatedColumns); // Notifica l'aggiornamento tramite onChangeData
       
      };
      
      const handleRemoveRow = (rowToRemove) => {
        const updatedRows = rows.filter(
          (row) => row.value !== rowToRemove.value || row.text !== rowToRemove.text
        ); // Rimuove la riga che ha esattamente lo stesso valore e testo
        setRows(updatedRows); // Aggiorna lo stato locale delle righe
        onChangeData(element.id, "rows", updatedRows); // Notifica l'aggiornamento tramite onChangeData
       
      };
      

      const deepClone = (obj) =>
        typeof structuredClone === "function"
          ? structuredClone(obj)
          : JSON.parse(JSON.stringify(obj));

          
          const copyColumn = (index) => {
            setColumns((prevColumns) => {
              const columnCopy = deepClone(prevColumns[index]); // Copia profonda
              columnCopy.id = uuidv4(); // Assegna un nuovo ID
              const updatedColumns = [...prevColumns, columnCopy]; // Aggiungi la copia alla fine
              // Chiamata a onChangeData usando lo stato aggiornato
              onChangeData(element.id, "columns", updatedColumns);
              return updatedColumns; // Aggiorna lo stato
            });
          };
          
          const moveColumnUp = (index) => {
            setColumns((prevColumns) => {
              if (index <= 0) return prevColumns; // Se è già in cima, non fare nulla
              const updatedColumns = [...prevColumns]; // Crea una copia dell'array
              const [column] = updatedColumns.splice(index, 1); // Rimuove la colonna
              updatedColumns.splice(index - 1, 0, column); // Inserisce una posizione sopra
              return updatedColumns; // Restituisce l'array aggiornato
            });
          };
          const moveColumnDown = (index) => {
            setColumns((prevColumns) => {
              if (index >= prevColumns.length - 1) return prevColumns; // Se è già in fondo, non fare nulla
              const updatedColumns = [...prevColumns]; // Crea una copia dell'array
              const [column] = updatedColumns.splice(index, 1); // Rimuove la colonna
              updatedColumns.splice(index + 1, 0, column); // Inserisce una posizione sotto
              return updatedColumns; // Restituisce l'array aggiornato
            });
          };


          const updateColumnById = (id, identifier, value) => {
            setColumns((prevColumns) => {
              // Aggiorna la colonna specifica
              const updatedColumns = prevColumns.map((column) =>
                column.id === id
                  ? { ...column, [identifier]: value } // Aggiorna la proprietà specifica
                  : column // Mantieni invariati gli altri oggetti
              );
          
              // Chiama onChangeData con lo stato aggiornato
              onChangeData(element.id, "columns", updatedColumns);
          
              return updatedColumns; // Aggiorna lo stato
            });
          
            
          };
    
    return (
        <Box
            bg="white"
            border="1px solid"
            borderColor="gray.300"
            borderRadius="md"
            p={6}
            shadow="md"
            position="relative"
            width="100%"
        >
            {/* Action Buttons */}
            <HStack spacing={2} position="absolute" top={2} left={2}>
                <Text fontWeight="bold" fontSize="md">
                    Matrix Question
                </Text>
                <Tooltip label="Edit" fontSize="sm">
                    <IconButton
                        size="sm"
                        aria-label="Edit"
                        icon={<EditIcon />}
                        onClick={onEdit}
                    />
                </Tooltip>
                <Tooltip label="Delete" fontSize="sm">
                    <IconButton
                        size="sm"
                        aria-label="Delete"
                        icon={<DeleteIcon />}
                        onClick={() => { isMatrixDropdownElement ? onDeleteMatrixDropdown() : onDelete() }}
                    />
                </Tooltip>
                <Tooltip label="Copy" fontSize="sm">
                    <IconButton
                        size="sm"
                        aria-label="Copy"
                        icon={<CopyIcon />}
                        onClick={() => { isMatrixDropdownElement ? onCopyMatrixDropdown() : onCopy() }}
                    />
                </Tooltip>
                <Tooltip label="Move Up" fontSize="sm">
                    <IconButton
                        size="sm"
                        aria-label="Move Up"
                        icon={<ArrowUpIcon />}
                        onClick={() => { isMatrixDropdownElement ? onMoveUpMatrixDropdown() : onMoveUp() }}
                    />
                </Tooltip>
                <Tooltip label="Move Down" fontSize="sm">
                    <IconButton
                        size="sm"
                        aria-label="Move Down"
                        icon={<ArrowDownIcon />}
                        onClick={() => { isMatrixDropdownElement ? onMoveDownMatrixDropdown() : onMoveDown() }}
                    />
                </Tooltip>
            </HStack>

            <VStack align="start" spacing={5} mt={8}>
                

                <FormControl>
                    <FormLabel fontWeight="bold">Title</FormLabel>
                    <Input
                        value={element.title}
                        placeholder="Enter Title"
                        onChange={(e) => onChangeData(element.id, "title", e.target.value)}
                    />
                </FormControl>


                <FormControl>
          <FormLabel fontWeight="bold">Tag</FormLabel>
          <Input
            value={element.name}
            placeholder="Enter Tag"
            onChange={(e) => onChangeData(element.id, "name", e.target.value)}
          />
         </FormControl>
                <Box display="flex" alignItems="center" gap="8px"> {/* gap per spaziatura */}
                <FormControl width="150px" mr={4}> {/* Aggiunto margine destro per spazio */}
        <FormLabel fontWeight="bold">Type</FormLabel>
        <Select
        placeholder="Select a type"
          value={selectedType}
          onChange={handleTypeChange}
        >
          <option value="dropdown">Dropdown</option>
          <option value="checkbox">Checkbox</option>
          <option value="radiogroup">Radiogroup</option>
          <option value="text">Text</option>
          <option value="comment">Comment</option>
          <option value="boolean">Boolean</option>
          <option value="rating">Rating</option>
        </Select>
      </FormControl>

      {selectedType && (
          <FormControl width="150px" mr={4} mt={8}> {/* Aggiunto margine destro per spazio */}
       
        <Button onClick={() => {  handleAddColumn({id: uuidv4(), cellType: selectedType})}}>
          Aggiungi
        </Button></FormControl>
      )}</Box>
                {selectedType && (
                    <Text>
                        Selected Option: <strong>{selectedType}</strong>
                    </Text>
                )}

                {/* {/* Additional render logic for specific types can go here 
                {element.type === "dropdown" && <Text>Render dropdown-specific inputs</Text>}
                {element.type === "checkbox" && (
                    <DraggableDropdownRadiogroupCheckboxCreationElement
                        element={element}
                        onDelete={onDelete}
                        onEdit={onEdit}
                        onCopy={onCopy}
                        onMoveUp={onMoveUp}
                        onMoveDown={onMoveDown}
                        // onChangeData={(id, identifier, value) => { updatePageSurvey(currentPageIndex, id, identifier, value) }}
                    />)}
                {element.type === "radiogroup" && (
                    <DraggableDropdownRadiogroupCheckboxCreationElement
                        element={element}
                        onDelete={onDelete}
                        onEdit={onEdit}
                        onCopy={onCopy}
                        onMoveUp={onMoveUp}
                        onMoveDown={onMoveDown}
                    />)}
                {element.type === "tagbox" && <Text>Render tagbox-specific inputs</Text>}
                {element.type === "text" && (
                    <DraggableTextCreationElement
                        element={element}
                        onDelete={onDelete}
                        onEdit={onEdit}
                        onCopy={onCopy}
                        onMoveUp={onMoveUp}
                        onMoveDown={onMoveDown}
                    />)}
                {element.type === "comment" && (
                    <DraggableCommentCreationElement
                        element={element}
                        onDelete={onDelete}
                        onEdit={onEdit}
                        onCopy={onCopy}
                        onMoveUp={onMoveUp}
                        onMoveDown={onMoveDown}
                    />)}
                {element.type === "boolean" && (
                    <DraggableBooleanCreationElement
                        element={element}
                        onDelete={onDelete}
                        onEdit={onEdit}
                        onCopy={onCopy}
                        onMoveUp={onMoveUp}
                        onMoveDown={onMoveDown}
                    />)}
                {element.type === "rating" && (
                    <DraggableRatingCreationElement
                        element={element}
                        onDelete={onDelete}
                        onEdit={onEdit}
                        onCopy={onCopy}
                        onMoveUp={onMoveUp}
                        onMoveDown={onMoveDown}
                    />)}*/}


<FormControl >
          <FormLabel fontWeight="bold">Elements DropDown</FormLabel>

  
          <VStack
  align="stretch"
  spacing={4}
  width="100%"
  height="350px" // Altezza massima per il contenitore
  maxHeight="350px"
  overflowY="auto" // Scorrimento verticale
  border="1px solid"
  borderColor="gray.200"
  borderRadius="md"
>
  <List spacing={4} width="100%">
    {columns.map((column, index) => (
      <ListItem
        key={index}
        display="flex"
        flexDirection="column" // Disposizione verticale
        justifyContent="flex-start"
        alignItems="stretch"
        border="1px solid"
        borderColor="gray.300"
        borderRadius="md"
        p={4} // Spaziatura interna
        bg="gray.50"
        _hover={{ bg: "gray.100", borderColor: "gray.400" }}
        width="100%" // Assicurati che occupi l'intera larghezza
      >
        <Tooltip label={`Type: ${column.cellType}`} aria-label="Column Type Tooltip">
          <Box width="100%">
            {column.cellType === "dropdown" ||
            column.cellType === "checkbox" ||
            column.cellType === "radiogroup" ? (
              <DraggableRankingDropdownRadiogroupCheckboxCreationElement
                name={column.cellType}
                isMatrixDropdownElement={true}
                element={column}


                onDeleteMatrixDropdown={() => handleRemoveColumn(column.id)}
                onCopyMatrixDropdown={() =>  {copyColumn(index); }}
                onMoveUpMatrixDropdown={() =>  {moveColumnUp(index); }}
                onMoveDownMatrixDropdown={() => moveColumnDown(index)}
                onChangeData={(id, identifier, value) => {updateColumnById(id, identifier, value)}}
              />
            ) : (
              ""
            )}

           
            {column.cellType === "text" && (
              <DraggableTextCreationElement

                element={column}
                onDelete={onDelete}
              
                onCopy={onCopy}
                onMoveUp={onMoveUp}
                onMoveDown={onMoveDown}

                isMatrixDropdownElement={true}

                onDeleteMatrixDropdown={() => handleRemoveColumn(column.id)}
                onCopyMatrixDropdown={() =>  {copyColumn(index); }}
                onMoveUpMatrixDropdown={() =>  {moveColumnUp(index); }}
                onMoveDownMatrixDropdown={() => moveColumnDown(index)}
                onChangeData={(id, identifier, value) => {updateColumnById(id, identifier, value)}}
              />
              )}

                  {column.cellType=== "comment" && (
                    <DraggableCommentCreationElement
                        element={column}
                        onDelete={onDelete}
                        onCopy={onCopy}
                        onMoveUp={onMoveUp}
                        onMoveDown={onMoveDown}

                        isMatrixDropdownElement={true}
                        onDeleteMatrixDropdown={() => handleRemoveColumn(column.id)}
                        onCopyMatrixDropdown={() =>  {copyColumn(index); }}
                        onMoveUpMatrixDropdown={() =>  {moveColumnUp(index); }}
                        onMoveDownMatrixDropdown={() => moveColumnDown(index)}
                        onChangeData={(id, identifier, value) => {updateColumnById(id, identifier, value)}}
                    />)}
                    {column.cellType === "boolean" && (
                    <DraggableBooleanCreationElement
                        element={column}
                        onDelete={onDelete}
                        onCopy={onCopy}
                        onMoveUp={onMoveUp}
                        onMoveDown={onMoveDown}

                        isMatrixDropdownElement={true}
                        onDeleteMatrixDropdown={() => handleRemoveColumn(column.id)}
                        onCopyMatrixDropdown={() =>  {copyColumn(index); }}
                        onMoveUpMatrixDropdown={() =>  {moveColumnUp(index); }}
                        onMoveDownMatrixDropdown={() => moveColumnDown(index)}
                        onChangeData={(id, identifier, value) => {updateColumnById(id, identifier, value)}}
                    />)}
                      {column.cellType === "rating" && (
                    <DraggableRatingCreationElement
                        element={column}
                        onDelete={onDelete}
                        onCopy={onCopy}
                        onMoveUp={onMoveUp}
                        onMoveDown={onMoveDown}

                        isMatrixDropdownElement={true}
                        onDeleteMatrixDropdown={() => handleRemoveColumn(column.id)}
                        onCopyMatrixDropdown={() =>  {copyColumn(index); }}
                        onMoveUpMatrixDropdown={() =>  {moveColumnUp(index); }}
                        onMoveDownMatrixDropdown={() => moveColumnDown(index)}
                        onChangeData={(id, identifier, value) => {updateColumnById(id, identifier, value)}} 
                    />)}
          </Box>
        </Tooltip>
      </ListItem>
    ))}
  </List>
</VStack>


        </FormControl>
<FormControl>
          <FormLabel fontWeight="bold">Rows</FormLabel>
     
          <HStack width="100%" spacing={3} align="center">
  <Input
    placeholder="Column Value"
    value={newRow.value}
    width="40%"  // Set a fixed width to inputs to allow space for the button
    onChange={(e) => setNewRow({ ...newRow, value: e.target.value })}
  />
  <Input
    placeholder="Column Text"
    value={newRow.text}
    width="40%"  // Set a fixed width to inputs to allow space for the button
    onChange={(e) => setNewRow({ ...newRow, text: e.target.value })}
  />
  <Button 
    colorScheme="blue" 
    onClick={handleAddRow}
    width="20%"    // Ensures the button takes up remaining space, keeping it visible
    minWidth="100px" // Ensures button is not too small even on wider screens
  >
    Add Row
  </Button>
</HStack>

          <VStack align="start" spacing={2} width="100%" maxHeight="350px" overflowY="auto">
            <List spacing={2} width="100%">
              {rows.map((row, index) => (
                <ListItem
                  key={index}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  border="1px solid"
                  borderColor="gray.200"
                  borderRadius="md"
                  p={2}
                  bg="gray.50"
                  _hover={{ bg: "gray.100" }}
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                >
                  <Tooltip label={row.text} aria-label="Row Text Tooltip">
                    <Text>Value: {row.value} Text:{row.text}</Text>
                  </Tooltip>
                  <IconButton
                    size="sm"
                    icon={<CloseIcon />}
                    aria-label="Remove row"
                    onClick={() => handleRemoveRow(row)}
                  />
                </ListItem>
              ))}
            </List>
          
          </VStack>
        </FormControl>

                <FormControl display="flex" alignItems="center">
                    <FormLabel mb="0" fontWeight="bold">
                        Required
                    </FormLabel>
                    <Switch
                        isChecked={element.isRequired}
                        onChange={(e) => onChangeData(element.id, "isRequired", e.target.checked)}
                    />
                </FormControl>
            </VStack>
        </Box>
    );
}

export default DraggableMatrixDropdownCreationElement;
